import {
  type CreatorStatistic,
  Retention,
  type TeamMemberStatistic,
} from '@api'

export const getSalary = (data: CreatorStatistic | TeamMemberStatistic) =>
  data.revenue - data.agencyProfit

export const RETENTION_LABELS: Record<Retention, string> = {
  [Retention.NONE]: 'None',
  [Retention.DAILY]: 'Daily',
  [Retention.WEEKLY]: 'Weekly',
  [Retention.MONTHLY]: 'Monthly',
  [Retention.YEARLY]: 'Yearly',
}
